import { render, staticRenderFns } from "./DatatableCampaignHistory.vue?vue&type=template&id=381bd2fa"
import script from "./DatatableCampaignHistory.vue?vue&type=script&lang=js"
export * from "./DatatableCampaignHistory.vue?vue&type=script&lang=js"
import style0 from "./DatatableCampaignHistory.vue?vue&type=style&index=0&id=381bd2fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports